import { Record } from 'immutable';

const MatchingAgencyAddRecord = Record({
  'matchingAgencyId': null,
  'taCode': null,
  'eventId': null
});

export class MatchingAgencyAdd extends MatchingAgencyAddRecord {
  matchingAgencyId: number;
  taCode: string;
  eventId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-add.ts